import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isMobile } from 'react-device-detect';
import { Paper, Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import moment from 'moment';
import { actionCreators } from './store.js';
import TaxInvoiceList from './TaxInvoiceList';
import {
  viewPdfFile as viewFileCallback,
  downloadPdfFile as downloadPdfFileCallback,
  getTaxInvoicePdfFileName,
} from '../utils/pdfUtils';

const styles = (theme) => ({
  headerContainer: {
    height: '80px',
    marginBottom: '22px',
  },
  headerContent: {
    height: '100%',
    padding: '0 30px',
  },
  messageContainer: {
    height: '521px',
    marginBottom: '60px',
    [theme.breakpoints.down('sm')]: {
      height: '252px',
      marginBottom: '0',
    },
  },
  messageContent: {
    color: '#666666',
    fontWeight: 'normal',
    height: '100%',
    '& h4': {
      fontWeight: 'normal',
      textAlign: 'center',
      lineHeight: '30px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
  },
});

class TaxInvoicesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      taxInvoices: null,
      adfitNo: '',
    };
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  componentDidMount = () => {
    const { match } = this.props;
    const matchSplit = match.url.split('/');
    const tab = matchSplit.length === 4 ? matchSplit[3] : '';
    this.setState({ tab: tab });
    this.setState({ adfitNo: match.params.adfitNo });
    this.loadTaxInvoices(match.params.adfitNo);
  };

  loadTaxInvoices = (adfitNo) => {
    const { getAllTaxInvoices } = this.props;
    if (this.shouldReloadData()) {
      getAllTaxInvoices(adfitNo);
    }
  };

  shouldReloadData = () => {
    const { match, adfitNo } = this.props;
    return adfitNo !== match.params.adfitNo;
  };

  handlePageClick = (data) => {
    window.scroll(0, 0);
    this.setState({ currentPage: data.selected });
  };

  handleRowClick = (event, row) => {
    const { getTaxInvoiceAsPdf } = this.props;
    const { adfitNo, startPeriod } = row;
    const fileName = getTaxInvoicePdfFileName(adfitNo, startPeriod);
    getTaxInvoiceAsPdf(
      adfitNo,
      moment(startPeriod).format('YYYY-MM-DD'),
      fileName,
      isMobile ? downloadPdfFileCallback : viewFileCallback
    );
  };

  render = () => {
    const {
      classes,
      adfitNo,
      taxInvoices,
      hasTaxIdentifier,
      settings,
      accounts,
      history,
    } = this.props;
    const { isTaxInvoiceEnabled, country } = settings;

    if (!adfitNo || isTaxInvoiceEnabled === null) {
      return null;
    }

    if (accounts === null || isTaxInvoiceEnabled === false) {
      history.push(`/Accounts`);
      return null;
    }

    const selectingAccount = accounts.find((a) => a.adfitNo === adfitNo);
    const { facilityName } = selectingAccount;
    const upperCaseCountry = (country || '').trim().toUpperCase();

    let body;
    if (hasTaxIdentifier) {
      if (taxInvoices.length > 0) {
        body = (
          <TaxInvoiceList
            adfitNo={adfitNo}
            taxInvoices={taxInvoices}
            handleRowClick={this.handleRowClick}
            onPageChange={this.handlePageClick}
            currentPage={this.state.currentPage}
          />
        );
      } else {
        body = (
          <Paper className={classes.messageContainer}>
            <Grid
              container
              alignItems="center"
              justify="center"
              className={classes.messageContent}>
              <Grid item>
                <Typography variant="h4">
                  No invoices were found.
                  <br />
                  Please check again next month.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        );
      }
    } else {
      body = (
        <Paper className={classes.messageContainer}>
          <Grid
            container
            alignItems="center"
            justify="center"
            className={classes.messageContent}>
            <Grid item>
              <Typography variant="h4">
                {upperCaseCountry === 'AUS'
                  ? `Sorry, we are unable to generate invoices as ${facilityName} does not have an ABN/ACN configured.`
                  : `Sorry, we are unable to generate invoices as ${facilityName} does not have a GST number configured.`}
                <br />
                {`Please get in touch with ${facilityName} for further information.`}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      );
    }

    return (
      <div>
        <Paper className={classes.headerContainer}>
          <Grid container alignItems="center" className={classes.headerContent}>
            <Grid item>
              <Typography variant="h4">Invoices</Typography>
            </Grid>
          </Grid>
        </Paper>
        {body}
      </div>
    );
  };
}

TaxInvoicesContainer.propTypes = {
  taxInvoices: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      adfitNo: state.taxInvoices.adfitNo,
      hasTaxIdentifier: state.taxInvoices.hasTaxIdentifier,
      taxInvoices: state.taxInvoices.taxInvoices,
      settings: state.settings,
      accounts: state.accountSelection.accounts,
    }),
    {
      getAllTaxInvoices: actionCreators.getAllTaxInvoices,
      getTaxInvoiceAsPdf: actionCreators.getTaxInvoiceAsPdf,
    }
  ),
  withStyles(styles)
)(TaxInvoicesContainer);
